import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['articleReactions'] = {},
  action: Action,
): RootState['articleReactions'] {
  switch (action.type) {
    case 'ADD_REACTION': {
      return {
        ...state,
        [action.payload.article_id]: action.payload,
      }
    }

    case 'REACTION_REMOVE': {
      delete state[action.payload]

      return state
    }

    default:
      return state
  }
}
